import { Form, message } from "antd";
import Router from "../..";
import { useUserStore } from "../../../stores/userStore";
import { VALIDATION_MESSAGES, validators } from "../../utils/Regex";

export const Profile = () => {
  const [form] = Form.useForm();
  const { loadUserInfo } = useUserStore();

  // 저장 처리
  const handleSave = async () => {
    const values = await form.validateFields([
      "first_name",
      "last_name",
      "email",
      "phone",
      "country",
      "street_address",
      "address_line",
      "city",
      "state_province",
      "postal_code",
      "marketing_agreement",
    ]);

    // 정규식 검증
    if (!validators.name(values.first_name)) {
      message.error(VALIDATION_MESSAGES.first_name.invalid);
      return false;
    }
    if (!validators.lastName(values.last_name)) {
      message.error(VALIDATION_MESSAGES.last_name.invalid);
      return false;
    }
    if (!validators.email(values.email)) {
      message.error(VALIDATION_MESSAGES.email.invalid);
      return false;
    }
    if (values.phone && !validators.phone(values.phone)) {
      message.error(VALIDATION_MESSAGES.phone.invalid);
      return false;
    }

    const updated = await Router.Api.updateUserInfo(values);
    if (updated) {
      await loadUserInfo();
      return true;
    }
    return false;
  };

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">내 정보</h2>
      <div className="w-full max-w-[600px]">
        <div className="mb-12">
          <Router.MyPageForm form={form} onSave={handleSave} />
        </div>
      </div>
    </div>
  );
};
